import { render, staticRenderFns } from "./NewsCreateForm.vue?vue&type=template&id=3518d28c&scoped=true"
import script from "./NewsCreateForm.vue?vue&type=script&lang=js"
export * from "./NewsCreateForm.vue?vue&type=script&lang=js"
import style0 from "./NewsCreateForm.vue?vue&type=style&index=0&id=3518d28c&prod&lang=scss&scoped=true"
import style1 from "./NewsCreateForm.vue?vue&type=style&index=1&id=3518d28c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3518d28c",
  null
  
)

export default component.exports